import { FC, useMemo } from "react";

import styles from "./VolumeShareTableChartTotalLabel.module.scss";
import { Translation } from "src/components";
import { calculateValueChangeStyle } from "src/utils";
import {
  renderTrendChangeColumn,
  calculatePieChartTableTotalValue,
  calculatePieChartTotalTableAdditionalValue,
} from "../../utils";

type Props = {
  data: (Widgets.VolumeShare.TableChartValue &
    Pick<Tracker.Data, "id" | "name">)[];
  valueFormatter?: (value: number) => string;
};

export const VolumeShareTableChartTotalLabel: FC<Props> = ({
  data,
  valueFormatter,
}) => {
  const totalValue = useMemo<number>(
    () => calculatePieChartTableTotalValue(data),
    [data],
  );

  const totalAdditionalValue = useMemo<number>(
    () => calculatePieChartTotalTableAdditionalValue(data),
    [data],
  );

  const formattedTotalValue = useMemo<string | number>(
    () => valueFormatter?.(totalValue) || totalValue,
    [totalValue, valueFormatter],
  );

  return (
    <div className={styles.wrapper}>
      <span>
        <Translation
          i18nKey="widget.volume_share.table.label.total"
          values={{ value: formattedTotalValue }}
          components={{
            additionalValue: (
              <span style={calculateValueChangeStyle(totalAdditionalValue)}>
                {renderTrendChangeColumn(totalAdditionalValue)}
              </span>
            ),
          }}
        />
      </span>
    </div>
  );
};
